<template>
  <nav class="flex" aria-label="Breadcrumb">
    <ol class="flex items-center space-x-4">
      <li v-for="(breadcrumb, index) in breadcrumbs" :key="breadcrumb.path" class="flex items-center">
        <div v-if="index > 0" class="flex items-center">
          <svg
            class="h-5 w-5 flex-shrink-0 text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
          </svg>
        </div>
        <RouterLink
          v-if="!breadcrumb.current"
          :to="breadcrumb.path"
          class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors"
        >
          {{ breadcrumb.name }}
        </RouterLink>
        <span
          v-else
          class="ml-4 text-sm font-medium text-gray-900"
          aria-current="page"
        >
          {{ breadcrumb.name }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, RouterLink } from 'vue-router'
import { generateBreadcrumbs } from '../router'

const route = useRoute()

const breadcrumbs = computed(() => generateBreadcrumbs(route))
</script>